import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
  IconButton as WoboIconButton,
  ThemeProvider,
} from '@workboard/wobo-ui';
import { updateAiType } from '../../actions/card.actions';
import { AiTypeIcon } from './aiTypeIcon';
import { AiTypeMenu } from './aiTypeMenu';
import { AiTypeSelectProps } from './types';

const IconButton = styled(WoboIconButton)`
  width: auto;
  height: auto;
`;

export function AiTypeSelect ({
  ai,
}: AiTypeSelectProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
  const buttonRef = useRef<HTMLElement>(null);
  const dispatch = useDispatch();
  const selectedType = +ai.type;

  const handleButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(buttonRef.current);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuTypeSelected = (newType) => {
    setAnchorEl(null);
    dispatch(updateAiType(ai.id, newType));
  };

  return (
    <ThemeProvider>
      <IconButton
        ref={buttonRef}
        onClick={handleButtonClick}
      >
        <AiTypeIcon
          type={ai.type}
          size={18}
        />
      </IconButton>
      <AiTypeMenu
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        onTypeSelected={handleMenuTypeSelected}
        selectedType={selectedType}
      />
    </ThemeProvider>
  );
}
